import React, { useState } from "react";

const GeneralChecklistStatusTypeValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  if (!error && !record.status) {
    error = true;
    errorMessage = "'Indicator Status' is required";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default GeneralChecklistStatusTypeValidator;
